import {
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    input,
    InputSignal,
    Signal,
    viewChildren,
} from '@angular/core';
import { DetailItem } from '../se-side-details-models';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'se-side-details-item',
    templateUrl: './se-side-details-item.component.html',
    styleUrls: ['./se-side-details-item.component.scss'],
    imports: [ MatTooltipModule, TranslateModule, UpperCasePipe ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeSideDetailsItemComponent {
    details : InputSignal<DetailItem[]> = input.required<DetailItem[]>();
    title : InputSignal<string> = input<string>('SecondaryColumns');

    keyElements : Signal<readonly ElementRef<HTMLElement>[]> = viewChildren<ElementRef<HTMLElement>>('key');
    valueElements : Signal<readonly ElementRef<HTMLElement>[]> = viewChildren<ElementRef<HTMLElement>>('value');


    tooltipDisabledMap: Signal<Map<HTMLElement, boolean>> = computed(() => {
        const keyElements = this.keyElements();
        const valueElements = this.valueElements();
        // Const _details not used but util for side effect 
        const _details = this.details();

        const map : Map<HTMLElement, boolean> = new Map();
        
        [...keyElements, ...valueElements].forEach((elRef) => {
            const el = elRef.nativeElement;
            map.set(el, el.scrollWidth <= el.clientWidth);
        });

        return map
    });

    _isTooltipDisabled(el: HTMLElement) {
        return this.tooltipDisabledMap().get(el) ?? true;
    }
}
